import { render, staticRenderFns } from "./GenericFaq.vue?vue&type=template&id=4e3e7062&scoped=true&name=generic-faq&"
import script from "./GenericFaq.vue?vue&type=script&lang=js&"
export * from "./GenericFaq.vue?vue&type=script&lang=js&"
import style0 from "./GenericFaq.vue?vue&type=style&index=0&id=4e3e7062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e7062",
  null
  
)

export default component.exports